import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-main-pag',
  templateUrl: './home-main-pag.component.html',
  styleUrls: ['./home-main-pag.component.sass']
})
export class HomeMainPagComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-pag/home-main-pag.component.ts